export default function FlightsSearchFormBaseController(
    $scope,
    $state,
    flightsUtils,
    trainsFactory,
    settingsCabinClasses,
    settingsAirlines,
    l10nService,
    timeSlots,
    authService
) {
    'ngInject';

            const _Adult = trainsFactory.params.Travelers.Adult.value;
            const _Infant = trainsFactory.params.Travelers.Infant.value;
            const _Child = trainsFactory.params.Travelers.Child.value;
            const _Class = trainsFactory.params.CabinClass;
            const _MaxTravellerCount = authService.getAvailableServicesFromSessionStorage().MaxTravelerAmount;

            $scope.module = trainsFactory.getModule();
            $scope.isFlights = trainsFactory.isFlights();
            $scope.isTrains = trainsFactory.isTrains();

            $scope.$state = $state;
            $scope.params = trainsFactory.params;
            $scope.options = trainsFactory.options;
            $scope.options.time = trainsFactory.getTimeOptions(timeSlots);

            /**
             * define options for dropdowns
             */
            $scope.options.airlines = settingsAirlines;
            $scope.options.cabinClasses = prepareCabinClassesOptions(settingsCabinClasses);
            $scope.options.adults = flightsUtils.makeTravellersOptions('Adult', _MaxTravellerCount ? Math.min(4, _MaxTravellerCount) : 4, false);
            $scope.options.infants = flightsUtils.makeTravellersOptions('Infant', _Adult, true);
            $scope.options.children = flightsUtils.makeTravellersOptions('Child', 4 - _Adult, true);
            $scope.options.time0 = angular.copy($scope.options.time);
            $scope.options.time1 = angular.copy($scope.options.time);
            $scope.options.time2 = angular.copy($scope.options.time);
            $scope.options.time3 = angular.copy($scope.options.time);

            $scope.frequentFlights = [];

            $scope.options.type = [
                {text: l10nService.localize('Leaving by'), value: 'false'}, {text: l10nService.localize('Arriving by'), value: 'true'},
            ];

            $scope.getFrequentFlightView = getFrequentFlightView;
            $scope.setSelectedFrequentFlight = setSelectedFrequentFlight;

            /**
             * Initial values
             */
            $scope.params.CabinClass = angular.copy(_Class || $scope.options.cabinClasses[1]);
            $scope.params.Travelers.Adult = angular.copy(_.find($scope.options.adults, {value: _Adult.toString()}));
            $scope.params.Travelers.Infant = angular.copy(_.find($scope.options.infants, {value: _Infant.toString()}));
            $scope.params.Travelers.Child = angular.copy(_.find($scope.options.children, {value: _Child.toString()}));
            $scope.params.TicketSearchSegments[0]._time
                = angular.copy($scope.params.TicketSearchSegments[0]._time) || angular.copy($scope.options.time0[0]);
            $scope.params.TicketSearchSegments[1]._time
                = angular.copy($scope.params.TicketSearchSegments[1]._time) || angular.copy($scope.options.time1[0]);
            $scope.params.TicketSearchSegments[2]._time
                = angular.copy($scope.params.TicketSearchSegments[2]._time) || angular.copy($scope.options.time2[0]);
            $scope.params.TicketSearchSegments[3]._time
                = angular.copy($scope.params.TicketSearchSegments[3]._time) || angular.copy($scope.options.time3[0]);
            delete $scope.params.SearchId;

            /**
             * * Init
             * * $scope.frequentFlights
             */
            getFrequentFlights();

            /**
             * Get frequent flights list
             */
            function getFrequentFlights() {
                trainsFactory.getFrequentFlights().then(function(flights) {
                    $scope.frequentFlights = flights;
                });
            }

            function getFrequentFlightView(flight) {
                const airportName = (flight.AirportName)
                    ? flight.AirportName
                    : getFrequentFlightAllLocationName();

                return _.template('{{cityName}}, {{countryCode}} - {{airportName}} ({{airportCode}})')({
                    cityName: flight.CityName,
                    countryCode: flight.CountryCode,
                    airportName,
                    airportCode: flight.AirportCode,
                });
            }

            function setSelectedFrequentFlight(model, field, viewModel) {
                return function(flight) {
                    viewModel.$setValidity('editable', true);
                    const name = flight.CityName + ', ' + flight.CountryCode;
                    const airport = flight.AirportName ? flight.AirportName : getFrequentFlightAllLocationName();
                    const Code = flight.AirportCode;
                    const DisplayString = name + ' - ' + airport + ' (' + flight.AirportCode + ')';

                    model[field] = {
                        name,
                        airport,
                        Code,
                        DisplayString,
                        IsCity: flight.IsCity,
                    };
                };
            }

            function getFrequentFlightAllLocationName() {
                return $scope.isFlights ? l10nService.localize('All Airports')
                    : l10nService.localize('All Train Stations');
            }

          function prepareCabinClassesOptions(cabinClasses) {
            return _.map(cabinClasses, function(cabinClass) {
              return {text: cabinClass.ClassName, value: cabinClass.Id};
            });
          }
}



// WEBPACK FOOTER //
// ./src/app/modules/trains-base/controllers/trains-search-form-base-controller.js